import { createFileRoute, redirect } from '@tanstack/react-router'
import { PayrollPaymentsScreen } from '@/features/payroll-runs/payroll-payments-screen'
import { hasGrant } from '@/lib/me'
import { canOpenPayrollPayments } from '@/lib/payroll-payments-access'

/**
 * Accounting pays posted payroll runs and posts those payments (spec D13).
 *
 * A custom role may hold only the pay key or only the payment-posting key, so
 * this route sits OUTSIDE the `accounting` layout and its accounting_report.view
 * gate (the trailing underscore keeps the URL, drops the parent). It still
 * renders in the same app shell; the API authorises every call.
 */
export const Route = createFileRoute('/_authenticated/accounting_/payroll-payments')({
  beforeLoad: ({ context }) => {
    if (!canOpenPayrollPayments((key) => hasGrant(context.queryClient, key))) {
      throw redirect({ to: '/' })
    }
  },
  component: PayrollPaymentsScreen,
})
